var React = require('react');

function ContentToboggan (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5,3.33c-.06-.13-.17-.24-.31-.29l-1.51-.51c-.14-.04-.29.05-.33.19-.04.13.03.27.16.32l1.47.49c-.95,1.86-2.19,1.8-3.39,1.47-.36-.1-.83-.24-1.36-.41l.47-1.41s.01-.1,0-.14c.2,0,.38-.12.45-.3h0c.08-.23-.04-.49-.28-.57h0L2.48.02c-.24-.08-.49.05-.57.29s.05.49.29.57h.03v.03l-.5,1.5-1.37-.49c-.14-.05-.29.02-.34.16-.05.14.02.29.16.34.02,0,.67.24,1.63.57h0c1.62.57,4.11,1.42,5.97,2.01.02.01.04.02.06.03.02,0,.05.01.07.01.62.2,1.17.37,1.57.48.41.13.83.2,1.25.21.88,0,1.95-.37,2.77-1.98.07-.13.08-.29.02-.42h-.02ZM2.72,1.07v-.02l5.55,1.87s-.05.06-.07.1l-.47,1.43c-1.73-.57-3.96-1.33-5.52-1.87l.5-1.5h0Z"}));
}

ContentToboggan.defaultProps = {"id":"Layer_1","version":"1.1","viewBox":"0 0 13.56 5.73"};

module.exports = ContentToboggan;

ContentToboggan.default = ContentToboggan;
